export default "__VITE_ASSET__DCQPrLpl__"